import { LineItemDrawer } from "./line-item.client";
import { LineItemPage } from "./lines-items-page.client";
interface props {
  isDrawer: boolean;
  onclose?: () => void;
}
export function LineItem({ isDrawer, onclose }: props) {
  if (isDrawer) {
    return <LineItemDrawer  onclose={onclose} />;
  }

  return <LineItemPage />;
}
